import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // First check localStorage for saved preference
    const saved = localStorage.getItem('preferredLanguage');
    if (saved) return saved;
    
    // Auto-detect browser language
    const browserLang = navigator.language || navigator.userLanguage;
    // Check if browser language starts with 'es' (Spanish)
    if (browserLang && browserLang.toLowerCase().startsWith('es')) {
      return 'es';
    }
    return 'en';
  });

  useEffect(() => {
    localStorage.setItem('preferredLanguage', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'es' : 'en');
  };

  const t = (enText, esText) => {
    return language === 'en' ? enText : esText;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
